<template>
  <div>
    <section class="home-main-container">
      <div class="navbar-free">
        <MenuLanding v-if="true" />
        <Menu :showMenuItems="showMenuItems" v-else />
      </div>
      <ModalSeasonSelect />
      <div class="season-and-team" :class="isMargin ? 'margin-section-season' : 'margin-section-season-player'">
        <NavBarTournamentButtonMobile />
      </div>
      <div class="home-main-container__menu-sections">
        <MenuSectionsLandingBets />
      </div>
      <div class="content-section" :class="isMargin ? 'margin-section' : 'margin-section-min'">
        <div><RouterView /></div>
      </div>
      <div class="statistics">
        <StatisticsModal :show="show" :game="objectGame" @closemodal="closemodal" />
      </div>
    </section>

    <Lives :show="booleanIsLiveGamesModalOpen" @close="setBooleanIsLiveGamesModalOpen(false)" />
    <Footer />
  </div>
</template>
<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';
import EventBus from '@/utils/event-bus';
export default {
  name: 'LandingMain',
  components: {
    Menu: () => import('@/components/Layout/Menu'),
    MenuLanding: () => import('@/components/Layout/MenuLandings'),
    ModalSeasonSelect: () => import('@/components/Elements/ModalSeasonSelect'),
    StatisticsModal: () => import('@/components/Modals/StatisticsModal'),
    NavBarTournamentButtonMobile: () => import('@/components/Elements/NavBarTournamentButtonMobileB2C'),
    MenuSectionsLandingBets: () => import('@/components/Elements/MenuSectionsLandingBets'),
    Footer: () => import('@/components/Sections/Main/Footer'),
    Lives: () => import('@/views/Lives'),
  },
  data() {
    return {
      objectMainContainer: null,
      show: false,
      showMenuItems: true,
      distance: 0,
      objectGame: {
        gameId: 0,
        gameStatus: 0,
        date: 0,
        seasonId: 0,
      },
    };
  },
  computed: {
    ...mapState('leagueGeneral', ['booleanIsLiveGamesModalOpen']),
    isMargin() {
      return !['player', 'team'].includes(this.$route.name);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        window.scrollTo({
          top: 0,
        });
      },
    },
    '$socket.connected': {
      immediate: true,
      handler(newValue) {
        this.updateIsSocketConnected(newValue);
      },
    },
  },
  methods: {
    ...mapMutations('general', ['setBooleanIsStatisticModalOpen']),
    ...mapMutations('leagueGeneral', ['setBooleanAreLiveGames', 'setBooleanIsLiveGamesModalOpen']),
    ...mapMutations('nextGeneral', ['updateIsSocketConnected', 'setMenuOptionActive']),

    async fillLiveGamesData(numberRetries = 3) {
      try {
        const response = await axios.get('https://qobetc4ze3.execute-api.us-east-2.amazonaws.com/prod/games/live');
        this.setBooleanAreLiveGames(!!(response.data && response.data.length));
      } catch (e) {
        if (numberRetries > 0) {
          await this.fillLiveGamesData(numberRetries - 1);
        } else {
          throw new Error(e);
        }
      }
    },
    openModal() {
      this.setBooleanIsStatisticModalOpen(true);
      this.show = true;
    },
    closemodal() {
      this.setBooleanIsStatisticModalOpen(false);
      this.show = false;
    },
    onClickGame(objectGame) {
      this.objectGame = objectGame;
      this.setMenuOptionActive(objectGame && objectGame.stringSectionName ? objectGame.stringSectionName : 'stats');
      this.openModal();
    },
  },
  created() {
    EventBus.$on('click-game', this.onClickGame);
    window.localStorage.removeItem('widget-team');
    this.fillLiveGamesData();
  },
};
</script>
<style>
html {
  background: white;
}
</style>
<style lang="scss" scoped>
.margin-section-season {
  @media screen and (max-width: 580px) {
    margin-top: 68px !important;
  }
}
.margin-section-season-player {
  @media screen and (max-width: 580px) {
    margin-top: 10px !important;
  }
}
.navbar-static {
  width: 100%;
  // position: -webkit-sticky;
  height: 72px;
}
.margin-section {
  margin-top: 72px !important;
}
.margin-section-min {
  margin-top: 0px !important;
}
.navbar-free {
  width: 100%;
  // position: -webkit-sticky;
  // position: fixed;
  // top: 0;
  // z-index: 6;
}
.statistics {
  z-index: 60 !important;
}
.home-main-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  min-height: 100%;
  position: relative;
  background: white;
  &__menu-sections {
    position: -webkit-sticky;
    position: sticky;
    padding-top: 6px;
    top: 72px;
    width: 100%;
    background-color: rgb(255, 255, 255);
    z-index: 2;
  }

  @media screen and (max-width: 1023px) {
    &__menu-sections {
      top: 52px;
    }
  }

  @media screen and (max-width: 390px) {
    &__menu-sections {
      //margin: 1em 0 2em;
    }
  }
}

.content-section {
  order: 4;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-top: 10px;
  padding-bottom: 70px;
  // padding-top: 20px;
  & > div {
    height: 100%;
  }
  @media screen and (max-width: 1024px) {
    margin-top: 20px;
  }
  @media screen and (max-width: 580px) {
    margin-top: 0px;
    padding-top: 0px;
  }
}

.section {
  order: 5;
}

.season-and-team {
  width: 100%;
  margin: 10px 0;
  display: none;

  @media screen and (max-width: 580px) {
    display: block;
  }
}

@media screen and (max-width: 767px) {
  .content-section {
    background-color: #ffffff !important;
  }
}
</style>
